'use strict';

angular.module('DoohApps').service('DoohHelper', ['$log', function ($log) {
    var _this = this;
    this.tcFormat = 'HH:mm'; //time calculation string format
    this.dcFormat = 'YYYY-MM-DD'; //date calculation string format
    this.dtcFormat = _this.dcFormat + ' ' + _this.tcFormat;

    this.getToday = function (customTime) {
        var today = moment().tz(
            localStorage.getItem('TimeZoneIANA') != null &&
                localStorage['TimeZoneIANA'] != ''
                ? localStorage['TimeZoneIANA']
                : 'Europe/Kiev'
        );
        var todayD = today.format(_this.dcFormat);
        var todayT = today.format(_this.tcFormat + ':ss');
        if (customTime == undefined)
            today = new Date(
                todayD.split('-')[0],
                todayD.split('-')[1] - 1,
                todayD.split('-')[2],
                todayT.split(':')[0],
                todayT.split(':')[1],
                todayT.split(':')[2]
            );
        else
            today = new Date(
                todayD.split('-')[0],
                todayD.split('-')[1] - 1,
                todayD.split('-')[2],
                customTime.split(':')[0],
                customTime.split(':')[1],
                0
            );
        return today;
    };

    this.momentToDate = function (momentDate, isTimeZero) {
        var date = new Date();
        var dateD = momentDate.format(_this.dcFormat);
        var dateT = momentDate.format(_this.tcFormat + ':ss');
        date = new Date(
            dateD.split('-')[0],
            dateD.split('-')[1] - 1,
            dateD.split('-')[2],
            isTimeZero ? 0 : dateT.split(':')[0],
            isTimeZero ? 0 : dateT.split(':')[1],
            isTimeZero ? 0 : dateT.split(':')[2]
        );
        return date;
    };

    this.dateToString = function (dateObject, includeTime) {
        return _this.dateToMoment(dateObject).format(includeTime ? _this.dtcFormat : _this.dcFormat);
    }

    this.dateToMoment = function (date, time) {
        if (typeof date == 'string') date = _this.stringToDate(date);
        if (time == undefined) {
            return moment([
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                date.getHours(),
                date.getMinutes()
            ]);
        } else {
            return moment([
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                time.split(':')[0],
                time.split(':')[1]
            ]);
        }
    };

    this.setTimeOfDate = function (date, time) {
        if (typeof date == 'string') date = _this.stringToDate(date);
        return new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            time.split(':')[0],
            time.split(':')[1],
            0
        );
    };

    this.stringToMoment = function (dateString) {
        if (typeof dateString != 'string') return moment(dateString);
        if (dateString.indexOf('T') > -1) {
            return moment(dateString, _this.dcFormat + 'T' + _this.tcFormat + ':ss');
        } else {
            return moment(dateString, _this.dtcFormat + ':ss');
        }
    };

    this.stringToDate = function (dateString, isTimeZero) {
        if (typeof dateString != 'string') return moment(dateString);
        return _this.momentToDate(_this.stringToMoment(dateString), isTimeZero);
    };

    this.stringToMomentNoTime = function (dateString) {
        if (typeof dateString != 'string') return moment(dateString);

        var splitDate = dateString.split(' ');

        if (dateString.indexOf('T') > -1) {
            splitDate = dateString.split('T');
            return moment(splitDate[0], _this.dcFormat);
        } else {
            return moment(splitDate[0], _this.dcFormat);
        }
    };

    this.executeFunctionByName = function (functionName, context, args) {
        if (typeof args != 'undefined' && args.length > 0)
            args = [].slice.call(args).splice(2);
        var namespaces = functionName.split('.');
        var func = namespaces.pop();
        for (var i = 0; i < namespaces.length; i++) {
            context = context[namespaces[i]];
        }
        return context[func].apply(this, args);
    };

    this.twoDigits = function (d) {
        if (0 <= d && d < 10) return '0' + d.toString();
        if (-10 < d && d < 0) return '-0' + (-1 * d).toString();
        return d.toString();
    };

    this.stringToDateObject = function (stringDate) {
        var splitEnd = typeof stringDate == 'string'
            ? stringDate.replace('T', ' ').split(' ')
            : stringDate.format(_this.dtcFormat).split(' ');
        return new Date(
            splitEnd[0].split('-')[0],
            splitEnd[0].split('-')[1] - 1,
            splitEnd[0].split('-')[2],
            splitEnd[1].split(':')[0],
            splitEnd[1].split(':')[1]
        );
    };

    this.validateFileExtention = function (fileType, name) {
        var isValid = false;
        if (fileType == '') {
            fileType = name.split('.').pop();
        }

        var list = $('input[type="file"]').attr('accept');
        if (list != undefined) {
            var allowedExtentions = list.split(',');

            if (allowedExtentions.length > 0)
                $.each(allowedExtentions, function (k, v) {
                    v = v.split('/')[1] != '*' &&
                        (v.split('/')[0] == 'video' || v.split('/')[0] == 'image')
                        ? v.split('/')[1]
                        : v.split('/')[0].trim().replace('.', '');

                    if (
                        v == fileType.split('/')[1] ||
                        v == fileType.split('/')[0] ||
                        v == _this.getExtentionByMimeType(fileType)
                    )
                        isValid = true;
                });
            else
                isValid = true;
        } else
            isValid = true;

        return isValid;
    };

    this.getExtentionByMimeType = function (type) {
        switch (type) {
            case 'video/x-ms-wmv':
                return 'wmv';
            case 'video/x-msvideo':
                return 'avi';
            case 'video/quicktime':
                return 'mov';
            case 'video/3gpp':
                return '3gp';
            case 'video/x-flv':
                return 'flv';
            case 'video/x-matroska':
            case 'mkv':
                return 'mkv';
            default:
                return '';
        }
    };

    this.getExtensionFromUrl = function (url) {
        var match = url.match(/\.(\w+)(?:\?|$)/) || [];
        return match.pop() || '';
    }

    this.getWatchers = function () {
        var root = angular.element(document.getElementsByTagName('html'));

        var watchers = [];

        var f = function (element) {
            angular.forEach(['$scope', '$isolateScope'], function (scopeProperty) {
                if (element.data() && element.data().hasOwnProperty(scopeProperty)) {
                    angular.forEach(
                        element.data()[scopeProperty].$$watchers,
                        function (watcher) {
                            watchers.push(watcher);
                        }
                    );
                }
            });

            angular.forEach(element.children(), function (childElement) {
                f(angular.element(childElement));
            });
        };

        f(root);

        // Remove duplicate watchers
        var watchersWithoutDuplicates = [];
        angular.forEach(watchers, function (item) {
            if (watchersWithoutDuplicates.indexOf(item) < 0) {
                watchersWithoutDuplicates.push(item);
            }
        });

        void 0;
        angular.forEach(watchersWithoutDuplicates, function (i) {
            void 0;
        });
    };

    this.getMonday = function (d) {
        d = new Date(d);
        var day = d.getDay(), diff = d.getDate() - day + (day == 0 ? -6 : 1);
        return new Date(d.setDate(diff));
    };

    this.isDateStringinFormat = function (date) {
        //check if date has format YYYY-MM-DD
        var regex = /^([0-9]{4}-[0-9]{1,2}-[0-9]{1,2}(\s[0-9]{1,2}:[0-9]{2})?)$/;
        return regex.test(date);
    };

    //find object element in array by property value
    this.findWithAttr = function (array, attr, value) {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] == value) {
                return i;
            }
        }
        return -1;
    };

    this.eventUtcToTimeZone = function (ev) {
        if (!ev.allDay && ev.GroupID == 0) {
            ev.start = _this.utcDateToTimeZone(ev.start, ev.timeZone).replace(' ', 'T');
            ev.end = _this.utcDateToTimeZone(ev.end, ev.timeZone).replace(' ', 'T');
            return ev;
        } else
            return ev;
    };

    this.utcDateToTimeZone = function (stringDate, timeZone) {
        return moment(moment.utc(stringDate).format())
            .tz(timeZone)
            .format(_this.dcFormat + ' ' + _this.tcFormat + ':ss');
    }

    this.isValidAndMatchID = function (ID, compareID) {
        if (ID == null || ID == undefined || ID == 0) return false;
        if (typeof compareID == 'undefined') return true;
        else if (ID == compareID) return true;
        else return false;
    };

    this.dateFormat = function (date, notime) {
        var tzName = moment.tz.guess();
        var d = moment(date).tz(tzName).format(_this.dcFormat);
        if (notime) return d;
        else return d + ' ' + moment(date).tz(tzName).format(_this.tcFormat);
    };

    this.timeCompare = function (time1, time2) {
        var t1 = new Date();
        var parts = time1.split(':');
        t1.setHours(parts[0], parts[1], 0, 0);
        var t2 = new Date();
        parts = time2.split(':');
        t2.setHours(parts[0], parts[1], 0, 0);

        // returns 1 if greater, -1 if less and 0 if the same
        if (t1.getTime() > t2.getTime())
            return 1;
        if (t1.getTime() < t2.getTime())
            return -1;
        return 0;
    };

    this.generateRandomString = function (length) {
        var text = '';
        var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    this.getProperty = function (obj, key, logError = true) {
        return key.split('.').reduce(function (o, x) {
            if (typeof o === 'undefined' && logError)
                $log.warn('parameter undefined: ' + x);
            return (typeof o === 'undefined' || o === null) ? null : o[x];
        }, obj);
    }

    Array.prototype.uniqueSchedules = function () {
        var a = this.concat();
        for (var i = 0; i < a.length; ++i) {
            for (var j = i + 1; j < a.length; ++j) {
                if (a[i].ScheduleId === a[j].ScheduleId) a.splice(j--, 1);
            }
        }
        return a;
    };

    Date.prototype.addDays = function (days) {
        var dat = new Date(this.valueOf());
        dat.setDate(dat.getDate() + days);
        return dat;
    };
}]);
